"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorType = void 0;
const date_fns_1 = require("date-fns");
const isEmptyish_1 = __importDefault(require("../isEmptyish"));
var ValidatorType;
(function (ValidatorType) {
    ValidatorType["required"] = "required";
    ValidatorType["reject"] = "reject";
    ValidatorType["date"] = "date";
    ValidatorType["dateNotToday"] = "dateNotToday";
    ValidatorType["dateFuture"] = "dateFuture";
    ValidatorType["datePast"] = "datePast";
    ValidatorType["applicantDOB"] = "applicantDOB";
    ValidatorType["number"] = "number";
    ValidatorType["range"] = "range";
    ValidatorType["lowerBound"] = "lowerBound";
    ValidatorType["upperBound"] = "upperBound";
})(ValidatorType = exports.ValidatorType || (exports.ValidatorType = {}));
const invalidInt = (value, condition) => {
    const parsed = Number.parseInt(value, 10);
    if (Number.isNaN(parsed))
        return true;
    return condition(parsed);
};
const computeValidator = (validator, value) => {
    if (validator.type === ValidatorType.required) {
        return (0, isEmptyish_1.default)(value) ? validator.errorText || 'Required' : undefined;
    }
    if (typeof value !== 'undefined' && value !== null) {
        if (validator.type === ValidatorType.reject) {
            return validator.values.includes(value) ? validator.errorText || 'Invalid' : undefined;
        }
        if (validator.type === ValidatorType.number) {
            return (value === ''
                || !/^-?[0-9]+$/.test(value)) ? validator.errorText || 'Must be a number' : undefined;
        }
        if (validator.type === ValidatorType.range) {
            const { errorText, values } = validator;
            const { minimum, maximum } = values;
            return (value === ''
                || invalidInt(value, (v) => v < minimum || v > maximum)) ? errorText || `Must be a number between ${minimum} and ${maximum}` : undefined;
        }
        if (validator.type === ValidatorType.lowerBound) {
            const { errorText } = validator;
            const { minimum } = validator.values;
            return (value === ''
                || invalidInt(value, (v) => v < minimum)) ? errorText || `Must be a number at least ${minimum}` : undefined;
        }
        if (validator.type === ValidatorType.upperBound) {
            const { errorText } = validator;
            const { maximum } = validator.values;
            return (value === ''
                || invalidInt(value, (v) => v > maximum)) ? errorText || `Must be a number at most ${maximum}` : undefined;
        }
        const dateNow = new Date(Date.now());
        if (validator.type === ValidatorType.date) {
            const dateValue = (0, date_fns_1.parse)(value, 'MM/dd/yyyy', new Date());
            return (value === ''
                || !(0, date_fns_1.isValid)(dateValue)
                || !/^[0-9]{1,2}.[0-9]{1,2}.[0-9]{4}$/.test(value)) ? validator.errorText || 'Must be a date in MM/dd/yyyy format' : undefined;
        }
        if (validator.type === ValidatorType.dateNotToday) {
            const dateValue = (0, date_fns_1.parseISO)(value);
            return (!(0, date_fns_1.isValid)(dateValue)
                || (0, date_fns_1.isSameDay)(dateValue, dateNow)) ? validator.errorText || 'Must not be today\'s date' : undefined;
        }
        if (validator.type === ValidatorType.dateFuture) {
            const dateValue = (0, date_fns_1.parseISO)(value);
            return (!(0, date_fns_1.isValid)(dateValue)
                || (!(0, date_fns_1.isSameDay)(dateValue, dateNow) && dateValue < dateNow)) ? validator.errorText || 'Must be a date in the future' : undefined;
        }
        if (validator.type === ValidatorType.datePast) {
            const dateValue = (0, date_fns_1.parseISO)(value);
            return (!(0, date_fns_1.isValid)(dateValue)
                || (!(0, date_fns_1.isSameDay)(dateValue, dateNow) && dateValue > dateNow)) ? validator.errorText || 'Must be a date in the past' : undefined;
        }
        if (validator.type === ValidatorType.applicantDOB) {
            const dateValue = (0, date_fns_1.parse)(value, 'MM/dd/yyyy', new Date());
            const approximateAge = (0, date_fns_1.differenceInYears)(new Date(), dateValue);
            return (value === ''
                || !(0, date_fns_1.isValid)(dateValue)
                || !/^[0-9]{1,2}.[0-9]{1,2}.[0-9]{4}$/.test(value)
                || approximateAge < 18
                || approximateAge > 110) ? validator.errorText || 'Must be a valid birth date in MM/dd/yyyy format' : undefined;
        }
    }
    return undefined;
};
const generateValidator = (validators) => (value) => {
    let result;
    validators.some((validator) => {
        result = computeValidator(validator, value);
        return typeof result !== 'undefined';
    });
    return result;
};
exports.default = generateValidator;
